import React from 'react'

export default function RishikeshHead({quoteHead}) {
  return (
    <>
    <section className="rishikesh-head">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-11">
                    <span>{quoteHead.title}</span>
                    <p>{quoteHead.desc}</p>
                </div>
            </div>
        </div>
    </section> 
    </>
  )
}
